// @flow
import jsonFetch from "common/services/fetch/jsonFetch"
import config from "../../consts/config"

export type Provider = "facebook" | "google"

const getUrl = () => window.reduxStore.getState().options.get("authApiUrl")

const getRedirectUrl = () => {
  const location = window.location.href.replace(/((utm_[a-z]+)|(session_[a-z]+))=[^&]+(&|$)/g, "")

  // Because oauth redirect is done on server we need get rid of hash
  // before adding oauth-login=true
  const hashLocation = location.indexOf("#")
  const withoutHash = hashLocation !== -1 ? location.substr(0, hashLocation) : location

  // Backend needs to escape characters ',' and '~' (used in search URLs).
  // These have special meaning in URL, so we simply replace them here.
  const backendUrl = withoutHash.replace(/,/g, "%2C").replace(/~/g, "%7E")

  return `${backendUrl}${backendUrl.includes("?") ? "&" : "?"}oauth-login=true`
}

export default function socialApi(provider: Provider): Promise<*> {
  return jsonFetch(`${getUrl()}/v1/oauth.getAuthorizationUrl`, {
    body: {
      provider_id: provider,
      app_id: config.userAppAppId,
      redirect_url: getRedirectUrl(),
    },
  })
}
